import { createPortal } from "react-dom";
//------------------------------------------
export default function Loader(){
    return createPortal(
        <div className = "myModal">
            <div className = "loader"></div>
        </div>
    , document.getElementById("app-root")!);
}